import { render, staticRenderFns } from "./ModalMessageActionDetails.vue?vue&type=template&id=2e6d4785&scoped=true"
import script from "./ModalMessageActionDetails.vue?vue&type=script&lang=js"
export * from "./ModalMessageActionDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageActionDetails.vue?vue&type=style&index=0&id=2e6d4785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d4785",
  null
  
)

export default component.exports